// extracted by mini-css-extract-plugin
module.exports = {"Container":"App_Container__10KOh"};